"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var universalCookies_1 = require("./universalCookies");
function getOwaCanaryCookie() {
    var serverRedirect = universalCookies_1.getCookie("targetServer");
    var owaCanaryCookieName = "X-OWA-CANARY" + (serverRedirect ? "_" + serverRedirect.toLocaleLowerCase() : "");
    var canaryCookie = universalCookies_1.getCookie(owaCanaryCookieName);
    // we only cache the canary when we find one
    if (!canaryCookie || canaryCookie.length == 0) {
        return owaCanaryCookieName + "_cookie_is_null_or_empty";
    }
    return canaryCookie;
}
exports.getOwaCanaryCookie = getOwaCanaryCookie;
function getOwaCanaryDebugCookie() {
    var serverRedirect = universalCookies_1.getCookie("targetServer");
    var owaCanaryDebugCookieName = "X-OWA-CANARY-DEBUG" + (serverRedirect ? "_" + serverRedirect.toLocaleLowerCase() : "");
    var debugCanary = universalCookies_1.getCookie(owaCanaryDebugCookieName);
    return debugCanary;
}
exports.getOwaCanaryDebugCookie = getOwaCanaryDebugCookie;
